import { buttonBase as o } from "./buttonBase2.mjs";
import { inputBase as i, inputLabel as r } from "./inputBase.mjs";
import { link as t } from "./link.mjs";
import { dialog as e } from "./dialog.mjs";
import { dialogTitle as m } from "./dialogTitle2.mjs";
import { dialogContent as u } from "./dialogContent2.mjs";
import { dialogActions as p } from "./dialogActions3.mjs";
import { linearProgress as l } from "./linearProgress.mjs";
import { circularProgress as a } from "./circularProgress2.mjs";
import { alert as n, alertTitle as M } from "./alert.mjs";
import { select as f } from "./select2.mjs";
import { stepper as g } from "./stepper.mjs";
import { button as s } from "./button2.mjs";
import { avatar as c } from "./avatar.mjs";
import { badge as d } from "./badge.mjs";
import { menu as B } from "./menu2.mjs";
import { menuItem as T } from "./menuItem2.mjs";
import { formHelperText as b } from "./formHelperText.mjs";
import { tableHead as A } from "./table.mjs";
import { chip as C } from "./chip2.mjs";
import { slider as S } from "./slider.mjs";
import { customSwitch as h } from "./switch.mjs";
import { toggleButton as D } from "./toggleButton.mjs";
import { toggleButtonGroup as H } from "./toggleButtonGroup.mjs";
const Y = {
  MuiButtonBase: o,
  MuiButton: s,
  MuiInputBase: i,
  MuiInputLabel: r,
  MuiLink: t,
  MuiDialog: e,
  MuiDialogTitle: m,
  MuiDialogContent: u,
  MuiDialogActions: p,
  MuiLinearProgress: l,
  MuiCircularProgress: a,
  MuiAlert: n,
  MuiAlertTitle: M,
  MuiSelect: f,
  MuiStepper: g,
  MuiAvatar: c,
  MuiBadge: d,
  MuiFormHelperText: b,
  MuiTableHead: A,
  MuiChip: C,
  MuiSlider: S,
  MuiSwitch: h,
  MuiMenu: B,
  MuiMenuItem: T,
  MuiToggleButton: D,
  MuiToggleButtonGroup: H
};
export {
  Y as componentsCustomized
};
//# sourceMappingURL=index307.mjs.map
